import AdminFundraises from './container';

export default AdminFundraises;
